export default __webpack_public_path__ + "static/media/star.a191003e.svg";